import { render, staticRenderFns } from "./Kraken-button.vue?vue&type=template&id=e019ef76&scoped=true"
import script from "./Kraken-button.vue?vue&type=script&lang=ts"
export * from "./Kraken-button.vue?vue&type=script&lang=ts"
import style0 from "./Kraken-button.vue?vue&type=style&index=0&id=e019ef76&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e019ef76",
  null
  
)

export default component.exports